import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

// import { gsap } from "gsap";
const latestNewsSwiper = function (barba) {

	const speed = 2000
	const swiper = new Swiper('.news-swiper', {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
		// speed: (speed / 2),
		runCallbacksOnInit: false,
		breakpoints: {
			// tailwind sizes:
			// 'sm': '640px'
			// 'md': '768px'
			// 'lg': '1024px'
			// 'xl': '1200px'
			// '2xl': '1480px'
			// '3xl': '1640px'

			// when window width is >= 640px
			640: {
				slidesPerView: 2,
				spaceBetween: 16,
			}
		}
	})
}

export default latestNewsSwiper
